import DrillData from '../data/drills-data.js';
import TableComponent from '../TableComponent.js';
import './DrillsPage.css';

const DrillsPage = () => {
  return (
    <>
      <section className="content-wrap">
        <h2>Drill Table</h2>
        <p>For educational purposes only.</p>
        <div id="table-div">
          <TableComponent data={DrillData} />
        </div>
      </section>
    </>
  );
};

export default DrillsPage;
